import React from "react";
import { Link } from "react-router-dom";
import { HeroSection } from "@/components/product/HeroSection";
import { FeatureGrid } from "@/components/product/FeatureGrid";
import { BeekeeperSection } from "@/components/product/BeekeeperSection";
import { SurveySection } from "@/components/product/SurveySection";
import { MoreProducts } from "@/components/product/MoreProducts";
import { Footer } from "@/components/product/Footer";
import { About } from "@/components/product/About";
import { VideoPlayer } from "@/components/product/videoPlayer";

export interface Product {
  id: string;
  name: string;
  description: string;
  image: string;
  price: number;
  cooperative: string;
  source?: string;
  shortDescription: string;
  expand?: {
    cooperative: {
      id: string;
      name: string;
      image: string;
      slug: string;
    };
  };
}

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-4">
      <div className="text-center">
        <div className="bg-[rgba(0,63,40,1)] h-32 w-32 rounded-2xl flex items-center justify-center mb-8 mx-auto"> 
          <img 
            src="/logo/dailokrishi-yellow.png" 
            alt="DailoKrishi Logo" 
            className="w-[80px] h-[80px]"
          />
        </div>
        <h1 className="text-3xl font-bold font-slate text-[rgba(0,63,40,1)] mb-4">
          DailoKrishi 
        </h1>
        <p className="text-xl text-[rgba(0,63,40,0.8)] max-w-[600px] mx-auto mb-8">
          Empowering farmers and consumers through transparent, traceable agriculture
        </p>
        <Link 
          to="/" 
          className="inline-block px-8 py-3 bg-[rgba(0,63,40,1)] text-white font-medium rounded-lg hover:bg-[rgba(0,63,40,0.9)] transition-colors duration-200"
        >
          Go to app
        </Link>
      </div>
      <div className="w-full max-w-[500px] overflow-hidden mt-12">
      </div>
    </div>
  );
};

export default Index;
